import React from 'react'
import { string, func } from 'prop-types'
import {
  Grid,
  Card,
  Media,
  Color,
  Paragraph,
  H3,
  Icon
} from '@cobalt/cobalt-react-components'
import { AvailableMFA } from '../../../constants/mfa'
import '../../../../assets/mfa-selector.css'

const renderMFAIcon = ({ icon, color, name, description }) => (
  <Media alignVerticalCenter={true}>
    <Icon name={icon} medium color={color} />
    <div className="mfa-card-title">
      <H3 asH5>{name}</H3>
    </div>
    <Paragraph color={Color.gray[600]}>{description}</Paragraph>
  </Media>
)

renderMFAIcon.propTypes = {
  icon: string,
  color: string,
  name: string,
  description: string
}

const renderArrowIcon = () => (
  <div className="co--push-v-center mfa-selector-arrow-icon">
    <Icon name={Icon.CHEVRON_RIGHT} small color={Color.gray[400]} />
  </div>
)

const SetupMFACard = ({ mfaType, onClick }) => (
  <Grid.Group verticalGutters={Grid.Group.HALF_VERTICAL_GUTTERS}>
    <Grid.Column all="100">
      <Card clickable small onClick={onClick}>
        <Card.Content>
          <Grid noPadding>
            <Grid.Group>
              <Grid.Column alignLeft all="max">
                {renderMFAIcon(AvailableMFA[mfaType.toUpperCase()])}
              </Grid.Column>
              <Grid.Column alignCenter all="min">
                {renderArrowIcon()}
              </Grid.Column>
            </Grid.Group>
          </Grid>
        </Card.Content>
      </Card>
    </Grid.Column>
  </Grid.Group>
)

SetupMFACard.propTypes = {
  mfaType: string.isRequired,
  onClick: func.isRequired
}

export default SetupMFACard
